import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBankStatementStore, useAuthStore, usePrePanStore } from '../redux';
import { useUIControlsStore } from '../redux/features/ui-controls';
import Event from '../utils/eventTracker';
import DataLakeTracker from '../utils/tracking/data-lake-tracker';

const InJourneyQuitModal = () => {
  const navigate = useNavigate();
  const { customerId, customerRefNum, Authorization, showReferralScreen } =
    useAuthStore();
  const { inJourneyQuitModalOpen, updateInJourneyQuitFlag, postpanackscreen } =
    useUIControlsStore();
  const { blockId } = usePrePanStore();
  const { journeyTypeEnum } = useBankStatementStore();

  const yesButtonClicked = () => {
    if (window.location.pathname === '/upload-bs') {
      navigate('/edit-profile');
      return;
    } else if (window.location.pathname === '/post-pan') {
      if (postpanackscreen) {
        Event('surrogate_popup_happy_with_limit');
        Event('Web_Happy_with_BRE1limit_click');
      }
    } else if (window.location.pathname === '/pre-pan') {
      if (showReferralScreen && blockId === 0) {
        DataLakeTracker({
          logEventType: 'event',
          eventName: 'WELCOME_DASHBOARD',
          eventValue: '',
          Authorization: Authorization,
          customerId: customerId,
          customerRefNum: customerRefNum,
        });
      }
    }
    if (journeyTypeEnum === 'EDIT_PROFILE') {
      navigate('/edit-profile');
    } else {
      navigate('/dashboard');
    }
    updateInJourneyQuitFlag(false);
  };

  const noButtonClicked = () => {
    updateInJourneyQuitFlag(false);
  };

  return (
    <>
      {inJourneyQuitModalOpen ? (
        <>
          <div
            className="res150-overlay fixed top-0 left-0 right-0 bottom-0 w-full h-full  overflow-hidden bg-gray-700 opacity-100 flex flex-col items-center justify-center z-50 p-2"
            style={{ background: 'rgb(0,0,0,0.8)' }}
          >
            <div className="bg-white rounded-lg flex flex-col m-auto p-3">
              {' '}
              <div className="max-w-[400px] text-center w-full flex flex-col justify-center items-center p-3">
                <p className="font-bold">Your application is still pending!</p>
                <br />
                <p className="font-normal">
                  Are you sure you want to leave?
                  <br />
                  You can come back anytime & continue.
                </p>
              </div>
              <div className="flex flex-row justify-center items-center">
                <button
                  id="yesquit3"
                  style={{
                    color: '#079F9F',
                    border: '1px solid #079F9F',
                    borderRadius: '5px',
                  }}
                  className="bg-whitetext-white inline-block m-1 px-2 py-2  rounded-lg text-sm font-semibold focus:outline-none tracking-wider transition duration-200 ease-in-out "
                  onClick={yesButtonClicked}
                >
                  Save & quit
                </button>
                <button
                  id="continue3"
                  className="bg-[#079F9F] text-white inline-block m-1 px-2 py-2  rounded-lg text-sm font-semibold focus:outline-none tracking-wider bg-accent text-text-light hover:bg-btn-active disabled:bg-[#045656] active:bg-btn-active transition duration-200 ease-in-out "
                  onClick={noButtonClicked}
                >
                  No, continue
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default InJourneyQuitModal;
